<form [formGroup]="uninsuredNonDigi">
  <axis-card>
    <axis-card-body>
      <h1 class="axis-h3">{{ nonDigital?.title }}</h1>
      <div
        class="axis-form-group"
        [ngClass]="{
          'has-axis-error':
            uninsuredNonDigi.get('rejectDigiSelect')?.invalid && uninsuredNonDigi.get('rejectDigiSelect').touched,
        }"
        [ngClass]="{ 'has-axis-required': selectedOption === '' }"
      >
        <label class="axis-control-label">{{ nonDigital?.label }}</label>
        <axis-radio-button-wrapper formControlName="rejectDigiSelect">
          @for (option of nonDigital?.radioOptions; track option) {
            <axis-radio
              [heading]="option.label"
              [value]="option.value"
              name="mailOptions"
              (changeDetect)="onOptionChange(option.value)"
            >
            </axis-radio>
          }
        </axis-radio-button-wrapper>
        @if (uninsuredNonDigi.get("rejectDigiSelect")?.invalid && uninsuredNonDigi.get("rejectDigiSelect").touched) {
          <div class="axis-error-block">Please select an Option.</div>
        }
      </div>
      @if (selectedOption === "mail") {
        <axis-card>
          <axis-card-body>
            <h2 class="axis-h4">{{ nonDigital?.addressForm?.formHeading }}</h2>
            <p>{{ nonDigital?.addressForm?.note }}</p>

            <div class="axis-grid axis-form-row">
              <div class="axis-col-md-6">
                <div
                  class="axis-form-group has-axis-required"
                  [ngClass]="{
                    'has-axis-error':
                      uninsuredNonDigi.get('rejInsuredName').value === '' &&
                      uninsuredNonDigi.get('rejInsuredName').touched,
                    'has-axis-required': uninsuredNonDigi.get('rejInsuredName').value === '',
                  }"
                >
                  <label
                    class="axis-control-label"
                    for="insuredName"
                    >Insured’s Name
                    <span
                      aria-hidden="true"
                      class="axis-required-indicator"
                      >*</span
                    ></label
                  >
                  <input
                    [attr.aria-describedby]="
                      uninsuredNonDigi.get('rejInsuredName').value === '' ? 'insuredNameError' : null
                    "
                    type="text"
                    class="axis-form-control"
                    id="insuredName"
                    formControlName="rejInsuredName"
                  />
                  <div
                    class="axis-error-block"
                    id="insuredNameError"
                  >
                    Please enter Insured Name.
                  </div>
                </div>
              </div>

              <div class="axis-col-md-6">
                <div
                  class="axis-form-group"
                  [ngClass]="{
                    'has-axis-error':
                      uninsuredNonDigi.get('rejInsuredMail').invalid && uninsuredNonDigi.get('rejInsuredMail').touched,
                    'has-axis-required': uninsuredNonDigi.get('rejInsuredMail').value === '',
                  }"
                >
                  <label
                    class="axis-control-label"
                    for="insuredEmail"
                    >Insured’s Email
                    <span
                      aria-hidden="true"
                      class="axis-required-indicator"
                      >*</span
                    ></label
                  >
                  <input
                    autocomplete="off"
                    axis-input-clear
                    type="email"
                    class="axis-form-control"
                    id="insuredEmail"
                    formControlName="rejInsuredMail"
                  />
                  <div
                    class="axis-error-block"
                    id="idMailError"
                    *ngIf="
                      uninsuredNonDigi.get('rejInsuredMail').invalid && uninsuredNonDigi.get('rejInsuredMail').touched
                    "
                  >
                    @if (uninsuredNonDigi.get("rejInsuredMail").hasError("pattern")) {
                      Please enter a valid Insured's Email Address.
                    } @else {
                      Please enter an Insured's Email Address.
                    }
                  </div>
                </div>
              </div>

              <div class="axis-col-md-6">
                <div
                  class="axis-form-group"
                  [ngClass]="{
                    'has-axis-error':
                      uninsuredNonDigi.get('rejInsuredAddress').value === '' &&
                      uninsuredNonDigi.get('rejInsuredAddress').touched,
                    'has-axis-required': uninsuredNonDigi.get('rejInsuredAddress').value === '',
                  }"
                >
                  <label
                    class="axis-control-label"
                    for="streetAddress"
                    >Street Address
                    <span
                      aria-hidden="true"
                      class="axis-required-indicator"
                      >*</span
                    ></label
                  >
                  <input
                    [attr.aria-describedby]="
                      uninsuredNonDigi.get('rejInsuredAddress').value === '' ? 'streetAddressError' : null
                    "
                    type="text"
                    class="axis-form-control"
                    id="streetAddress"
                    formControlName="rejInsuredAddress"
                  />
                  <div class="axis-help-block">This address is where the documentation for signature will be sent.</div>
                  @if (uninsuredNonDigi.get("rejInsuredAddress").value === "") {
                    <div
                      class="axis-error-block"
                      id="streetAddressError"
                    >
                      Please enter Street Address.
                    </div>
                  }
                </div>
              </div>

              <div class="axis-col-md-6">
                <div
                  class="axis-form-group"
                  [ngClass]="{
                    'has-axis-error':
                      uninsuredNonDigi.get('rejInsuredCity').value === '' &&
                      uninsuredNonDigi.get('rejInsuredCity').touched,
                    'has-axis-required': uninsuredNonDigi.get('rejInsuredCity').value === '',
                  }"
                >
                  <label
                    class="axis-control-label"
                    for="city"
                    >City
                    <span
                      aria-hidden="true"
                      class="axis-required-indicator"
                      >*</span
                    ></label
                  >
                  <input
                    type="text"
                    class="axis-form-control"
                    id="city"
                    formControlName="rejInsuredCity"
                  />
                  @if (uninsuredNonDigi.get("rejInsuredCity").value === "") {
                    <div
                      class="axis-error-block"
                      id="businessCityError"
                    >
                      Please enter City.
                    </div>
                  }
                </div>
              </div>

              <div class="axis-col-md-6">
                <div
                  class="axis-form-group has-axis-required"
                  [ngClass]="{
                    'has-axis-error':
                      uninsuredNonDigi.get('rejInsuredState').value?.length < 1 &&
                      uninsuredNonDigi.get('rejInsuredState').touched &&
                      dropdownErrorBlurred,
                    'has-axis-required': uninsuredNonDigi.get('rejInsuredState').value === '',
                  }"
                >
                  <label
                    class="axis-control-label"
                    for="state"
                    >State
                    <span
                      aria-hidden="true"
                      class="axis-required-indicator"
                      >*</span
                    ></label
                  >
                  <axis-dropdown
                    id="state"
                    [dataProvider]="stateList"
                    (focus)="dropdownErrorBlurred = false"
                    formControlName="rejInsuredState"
                  ></axis-dropdown>
                  <div class="axis-error-block">Please select State.</div>
                </div>
              </div>

              <div class="axis-col-md-6">
                <div
                  class="axis-form-group has-axis-required"
                  [ngClass]="{
                    'has-axis-error':
                      uninsuredNonDigi.get('rejInsuredZipCode').invalid &&
                      uninsuredNonDigi.get('rejInsuredZipCode').touched,
                    'has-axis-required': uninsuredNonDigi.get('rejInsuredZipCode').value === '',
                  }"
                >
                  <label
                    class="axis-control-label"
                    for="zipCode"
                    >Zip Code
                    <span
                      aria-hidden="true"
                      class="axis-required-indicator"
                      >*</span
                    ></label
                  >
                  <input
                    type="text"
                    [axisInputNumber]="mySettings110"
                    class="axis-form-control"
                    id="zipCode"
                    formControlName="rejInsuredZipCode"
                  />

                  @if (uninsuredNonDigi.get("rejInsuredZipCode").value === "") {
                    <div
                      class="axis-error-block"
                      id="businessZipCodeError"
                    >
                      Please enter a Zip Code.
                    </div>
                  }

                  @if (
                    uninsuredNonDigi.get("rejInsuredZipCode").value !== "" &&
                    uninsuredNonDigi.get("rejInsuredZipCode").invalid &&
                    uninsuredNonDigi.get("rejInsuredZipCode").hasError("pattern") &&
                    uninsuredNonDigi.get("rejInsuredZipCode").touched
                  ) {
                    <div
                      class="axis-error-block"
                      id="businessZipCodeError"
                    >
                      Please enter a valid Zip Code.
                    </div>
                  }
                </div>
              </div>
            </div>
          </axis-card-body>
        </axis-card>
        <div class="axis-vertical-space _mtb-large">
          <p class="_text-bold _mtb-large">
            {{ nonDigital?.rejectionMessage }}
          </p>
          <p>{{ nonDigital?.rejectionOptMessage }}</p>
          <p class="_text-bold">
            {{ nonDigital?.backToDigitalLabel }}
            <a (click)="backConsentPage()"> click here </a>.
          </p>
        </div>
      }
      @if (selectedOption === "download") {
        <axis-card id="outstandingCard">
          <axis-card-body>
            <h1 class="axis-h3">
              We have received your rejection of electronically selecting and signing your selection forms.
            </h1>
            @if (content) {
              <p
                class="_mtb-large"
                [innerHTML]="content"
              ></p>
            }
            <p class="_text-bold _mtb-large">
              If you prefer to electronically select coverage and electronically sign your selection forms, please
              <a
                routerLink="/insured/uimui-consent"
                [queryParams]="{ key: requestKey }"
                >click here.</a
              >
            </p>
          </axis-card-body>
        </axis-card>
      }
    </axis-card-body>
  </axis-card>

  @if (userRole === "insured" || (userRole == "broker" && selectedOption == "digital")) {
    <div class="axis-btn-wrapper">
      <div class="axis-btn-wrapper-right">
        <button
          axis-button
          class="kind-primary"
          (click)="onContinue()"
        >
          <span class="axis-btn-icon-text">Continue</span>
        </button>
      </div>
    </div>
  }
</form>
